<template>
  <div class="bookdropComp">
    <navbar_staff />
    <div class="space"></div> 
    <!-- <div class="space_avatar"></div> -->
  
   <b-container>
    
    <div class="circle_content">
        <div class="circle_floting">
          <div class="circle">
            <span class="circle__btn">
              <img
                class="circle_img"
                :src="require('@/assets/avatars/' + code + '.jpg')"
                alt=""
              />
              <!-- <ion-icon class="pause" name="pause"></ion-icon>
            <ion-icon class="play" name="play"></ion-icon> -->
            </span>
            <span class="circle__back-1"></span>
            <span class="circle__back-2"></span>
          </div>
        </div>
      </div>
   </b-container>
  </div>
</template>

<script>

import navbar_staff from '../layouts/navbar_staff.vue';
import axios from "axios";
export default {
components:{navbar_staff}
,
data(){
    return{
       
        token: "dQpojB8WkH7HAZdh223jaqFSB1x5RYoKBjU0BAaVZt8DTVaxO5Sx5DlsErA2Zsu",
      code: "",
      ready: [],
      newjobs: [],
      myjobs: [],
      packing: [],
      keyword: "",
      detail: [],
      onlocker: [],
      myorders: [],
    }
},
mounted(){
    // this.gethistory();
    if (localStorage.getItem("auth") != null) {
      let c = JSON.parse(localStorage.getItem("auth"));
      this.code = c.std_code;
    }
   
},
methods:{
    gethistory() {
      let data = {
        token: this.token,
        staff_code: this.code,
      };
      const headers = {
        "content-type": "application/json",
      };
      this.$isLoading(true);
      axios
        .post("https://smartlibrary.ubru.ac.th/api/booking/get_history", data, {
          headers,
        })
        .then((res) => {
          // console.log(res);
          this.ready = res.data.dasboard[0].ready;
          this.packing = res.data.dasboard[0].packing;
          this.newjobs = res.data.dasboard[0].neworders;
          this.myjobs = res.data.dasboard[0].myjob;
          this.onlocker = res.data.OnLockers;
          // console.log(this.onlocker);
          this.myorders = res.data.MyOrders;
          this.items = res.data.AllOrders;
          this.$isLoading(false);
          // console.log(typeof this.items[0].mustbeget_date);
        });
    },
}
}
</script>

<style lang="scss" scoped>
.bookdropComp {
    background: var(--greyLight-1) no-repeat center center;
    background-size: cover;
    min-height: 100vh;
    position: absolute;
    width: 100%;
  }
  .space {
    height: 100px;
  }

/*  Avatar BUTTON  */
.circle_content {
    position: relative;
  }
  .circle_img {
    width: 100%;
    height: auto;
    border-radius: 50%;
  }
  .circle_floting {
    position: absolute;
    top: -10px;
    left: -22px;
    font-size: 14px;
  }
  .circle {
    grid-column: 2/3;
    grid-row: 4/6;
    width: 8rem;
    height: 100%;
    justify-self: center;
    border-radius: 1rem;
    display: grid;
    grid-template-rows: 1fr;
    justify-items: center;
    align-items: center;
  }
  .circle__btn {
    grid-row: 1/2;
    grid-column: 1/2;
    width: 9rem;
    height: 6rem;
    display: flex;
    margin: 0.6rem;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    font-size: 3.2rem;
    color: var(--primary);
    z-index: 300;
    background: var(--greyLight-1);
    box-shadow: 0.3rem 0.3rem 0.6rem var(--greyLight-2),
      -0.2rem -0.2rem 0.5rem var(--white);
    cursor: pointer;
    position: relative;
  }
  .circle__btn.shadow {
    box-shadow: inset 0.2rem 0.2rem 0.5rem var(--greyLight-2),
      inset -0.2rem -0.2rem 0.5rem var(--white);
  }
  .circle__btn .play {
    position: absolute;
    opacity: 0;
    transition: all 0.2s linear;
  }
  .circle__btn .play.visibility {
    opacity: 1;
  }
  .circle__btn .pause {
    position: absolute;
    transition: all 0.2s linear;
  }
  .circle__btn .pause.visibility {
    opacity: 0;
  }
  .circle__back-1,
  .circle__back-2 {
    grid-row: 1/2;
    grid-column: 1/2;
    width: 6rem;
    height: 6rem;
    border-radius: 50%;
    filter: blur(1px);
    z-index: 100;
  }
  .circle__back-1 {
    box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
      -0.4rem -0.4rem 0.8rem var(--white);
    background: linear-gradient(
      to bottom right,
      var(--greyLight-3) 0%,
      var(--white) 100%
    );
    -webkit-animation: waves 4s linear infinite;
    animation: waves 4s linear infinite;
  }
  .circle__back-1.paused {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
  .circle__back-2 {
    box-shadow: 0.4rem 0.4rem 0.8rem var(--greyLight-3),
      -0.4rem -0.4rem 0.8rem var(--white);
    -webkit-animation: waves 4s linear 2s infinite;
    animation: waves 4s linear 2s infinite;
  }
  .circle__back-2.paused {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
  
  @-webkit-keyframes waves {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
  
  @keyframes waves {
    0% {
      transform: scale(1);
      opacity: 1;
    }
    50% {
      opacity: 1;
    }
    100% {
      transform: scale(2);
      opacity: 0;
    }
  }
  /*END */
</style>